/**
 * Land single post views with the hero image's frame aligned to
 * the viewport top — the same position the card → hero view transition
 * scrolls to — so every arrival matches, not only clicks on feed
 * cards. Category/tag and index pages have no hero and are untouched.
 *
 * Skips back/forward and reload navigations (the browser restores the
 * previous scroll position), anchor links, and pages already scrolled.
 */
export default function heroScrollAlign() {
    const nav = performance.getEntriesByType('navigation')[0] as
        PerformanceNavigationTiming | undefined;
    if (nav && nav.type !== 'navigate') { return; }
    if (location.hash || window.scrollY > 0) { return; }
    const frame = document.querySelector(
        'main.single-post .perspective-container figure.post-media');
    if (!frame) { return; }
    // Align the figure's border box, matching the view-transition
    // scroll target in view-transitions.ts.
    window.scrollTo({
        top: window.scrollY + frame.getBoundingClientRect().top,
        behavior: 'instant'
    });
}
